<app-base-overlay [title]="'Create New Company'">
  <div body>
    <form [formGroup]="createNewCompanyForm" class="flex flex-col gap-3">
      <div class="grid lg:grid-cols-2 gap-4">
        <app-text-input [label]="'First Name'" formControlName="firstName"
                                placeholder="Ex: John" class="w-full" [fullWidth]="true"></app-text-input>
        <app-text-input [label]="'Last Name'" formControlName="lastName"
                                placeholder="Ex: Bravo" class="w-full" [fullWidth]="true"></app-text-input>
      </div>
      <div class="grid lg:grid-cols-2 gap-4">
        <app-text-input [label]="'Company Name'" formControlName="companyName"
                                placeholder="Ex: XYZ LLC" class="w-full" [fullWidth]="true"></app-text-input>
      </div>

      <div class="grid lg:grid-cols-2 gap-4">
        <app-text-input formControlName="email" label="Email" placeholder="Ex: johnBravo@gmail.com"
                                class="w-full"
                                [fullWidth]="true"></app-text-input>
        <app-text-input formControlName="password" label="Password"
                                class="w-full" [type]="'password'" placeholder="***********"
                                [fullWidth]="true"></app-text-input>
      </div>
      <app-text-input formControlName="phoneNumber" label="Phone Number" placeholder="Ex: +1 123-456-78XX"
                              class="w-full"
                              [fullWidth]="true"></app-text-input>
      <div class="grid lg:grid-cols-2 gap-4">
        <app-dropdown
          formControlName="companyType"
          [title]="'Business Entity'"
          [display]="'name'"
          [value]="'id'"
          [enableSearch]="true"
          [noDataMessage]="'No Options Available'"
          [items]="companyTypesState.response()?.data ?? []"
          [fullWidth]="true">
        </app-dropdown>

        <app-text-input formControlName="dotNumber" label="DOT #" placeholder="Ex: USDOT152XXX" class="w-full"
                                [fullWidth]="true"></app-text-input>
      </div>
    </form>
  </div>
  <div actions>
    <app-button class="py-2" [fullWidth]="true" type="submit" (click)="onCreateNewCompanyClicked()"
                [loading]="createNewCompanyState.loading()">Submit
    </app-button>
  </div>
</app-base-overlay>
